// KitchenSavvi Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  console.log('KitchenSavvi Theme Loaded');
  
  // Burger menu toggle
  const burgerMenu = document.getElementById('burgerMenu');
  const navMenu = document.getElementById('navMenu');
  
  if (burgerMenu && navMenu) {
    burgerMenu.addEventListener('click', function() {
      burgerMenu.classList.toggle('active');
      navMenu.classList.toggle('active');
    });
    
    // Close menu when a link is clicked
    document.querySelectorAll('.nav-menu .nav-link').forEach(link => {
      link.addEventListener('click', function() {
        burgerMenu.classList.remove('active');
        navMenu.classList.remove('active');
      });
    });
  }
  
  // Scroll spy for section menu ONLY - never touch main-nav
  const sectionLinks = document.querySelectorAll('.section-menu .nav-link');
  const currentUrl = window.location.pathname;
  
  // Make sure NO active state is ever set on main-nav links
  document.querySelectorAll('.nav-menu .nav-link').forEach(link => {
    link.classList.remove('active');
  });
  
  // Highlight nav on scroll - scroll spy for section menu
  const sections = document.querySelectorAll('section');
  if (sections.length > 0 && sectionLinks.length > 0) {
    window.addEventListener('scroll', () => {
      let current = '';
      
      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        if (window.pageYOffset >= sectionTop - 200) {
          current = section.getAttribute('id');
        }
      });

      sectionLinks.forEach(link => {
        // Only manage active state for links with data-section attribute
        if (link.getAttribute('data-section')) {
          link.classList.remove('active');
          // Always highlight Details on product pages as fallback
          if (currentUrl.includes('/products/') && link.getAttribute('data-section') === 'product-details-section' && current === '') {
            link.classList.add('active');
          }
          else if (link.getAttribute('data-section') === current) {
            link.classList.add('active');
          }
        }
      });
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && document.querySelector(href)) {
        e.preventDefault();
        document.querySelector(href).scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });

  // Form validation
  const forms = document.querySelectorAll('form');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const inputs = this.querySelectorAll('input[required], textarea[required]');
      let isValid = true;
      
      inputs.forEach(input => {
        if (!input.value.trim()) {
          input.style.borderColor = '#ff6b6b';
          isValid = false;
        } else {
          input.style.borderColor = '';
        }
      });
      
      if (!isValid) {
        e.preventDefault();
        showNotification('Please fill in all required fields', 'error');
      }
    });
  });

  // Button hover effect
  document.querySelectorAll('.btn').forEach(button => {
    button.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
    });
    button.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });
});

// Toggle FAQ items
function toggleFAQ(button) {
  const faqItem = button.parentElement;
  
  // Close all other items
  document.querySelectorAll('.faq-item').forEach(item => {
    if (item !== faqItem) {
      item.classList.remove('active');
    }
  });

  // Toggle current item
  faqItem.classList.toggle('active');
}

// Show notification
function showNotification(message, type = 'success') {
  const notification = document.createElement('div');
  notification.className = `notification notification-${type}`;
  notification.textContent = message;

  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 15px 20px;
    background-color: ${type === 'success' ? '#b5ffed' : '#ff6b6b'};
    color: #333;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    font-weight: 600;
    font-size: 14px;
    animation: slideIn 0.3s ease-in-out;
  `;

  document.body.appendChild(notification);

  // Remove after 3 seconds
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease-in-out';
    setTimeout(() => notification.remove(), 300);
  }, 3000);
}

// CSS Animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
document.head.appendChild(style);

// Add to cart handler (example)
function addToCart(productId) {
  const quantity = 1;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: productId,
          quantity: quantity
        }
      ]
    })
  })
  .then(response => response.json())
  .then(data => {
    showNotification('Added to cart!');
    updateCartCount();
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification('Error adding to cart', 'error');
  });
}

// Update cart count
function updateCartCount() {
  fetch('/cart.json')
    .then(response => response.json())
    .then(data => {
      const cartCount = data.item_count;
      // Update your cart counter element here
      const cartCounter = document.querySelector('.cart-count');
      if (cartCounter) {
        cartCounter.textContent = cartCount;
      }
    });
}

// Lazy load images
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.add('loaded');
        observer.unobserve(img);
      }
    });
  });

  document.querySelectorAll('img[data-src]').forEach(img => imageObserver.observe(img));
}
